export enum ListMenuType {
  LABEL = 'label',
  CHECKBOX = 'checkbox',
}
